import React from 'react';
import styles from './Performance.module.css';

interface FULFILLEDComponent extends React.FC {
  title?: string;
}

const FULFILLED: FULFILLEDComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Metric Description</div>
        <p>
          This is the number of orders that have been closed out in the past 90 days.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Output Description</div>
        <p>
          The operational details of the orders in this state are included in the output:
        </p>
        <ol>
          <li>Channel (B2B or B2C)</li>
          <li>Store Number</li>
          <li>Order Date</li>
          <li>Order Time</li>
          <li>Validate Stock Time (Hours) (only applies to In-Store Pick orders)</li>
          <li>Actual Ship Date (for Ship to Store orders only)</li>
          <li>Expected Customer Pickup/Delivery Date (what the customer was promised on acehardware.com for a pickup or delivery date)</li>
          <li>Actual Customer Pickup/Delivery Date (will be blank)</li>
          <li>Customer Order Number</li>
          <li>Final Fulfill Type</li>
          <li>Total (Customer Charge)</li>
          <li>Order Status</li>
        </ol>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Supporting Details</div>
        <p>
          Login to{' '}
          <a 
            href="http://www.acelearningplace.com" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            www.acelearningplace.com
          </a>
          {' '}After logging in, click this link:{' '}
          <a 
            href="https://acehardware-acecorporate.sabacloud.com/Saba/Web_spf/NA9P1PRD003/app/shared;spf-url=common%2Fledetail%2F0000030419%2Flatestversion" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get the Most Out of Acehardware.com with Enhanced Reporting
          </a>
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Update Cadence</div>
        <p>
          Daily with rolling 90 days.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Learn More</div>
        <p>
          Review this to view all of your store&apos;s orders that have been closed out within the past 90 days.
        </p><br/>
        <p>
          For additional guidance review the Ace Way of Retailing acehardware.com fulfillment{' '}
          <a 
            href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Store Procedures
          </a>
        </p>
      </div>
    </div>
  );
};

FULFILLED.title = 'Fulfilled';
export default FULFILLED;
